export const REDUCER_NAME = 'analytics'


const PHASE_NAME_LIST = {
    lead: 'Lead',
    setSalesOrder: 'Set',
    treatment: 'Treatment',
}

export const getPhaseName = (id) => {
    return PHASE_NAME_LIST[id]
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/const.js